import styled, { css } from 'styled-components';

import { colors } from '@bitcoin-portal/verse-web-components/dist/themes/colors';

export const Wrapper = styled.div`
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 1fr;
  text-align: center;

  gap: 16px;
  padding: 24px;

  width: 100%;

  & > a {
    color: ${colors.white};
    display: flex;
    align-items: center;
    flex-flow: row nowrap;
    justify-content: center;
  }

  & > a > svg {
    transform: rotate(270deg);
    color: ${colors.exclusive100};
    padding-top: 12px;
    min-width: 16px;
  }
`;

export const Divider = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 12px;
  width: 100%;
  align-items: center;
  color: ${colors.exclusive100};
`;

export const Line = styled.div<{ reverse?: boolean }>`
  ${({ reverse }) => css`
    width: 100%;
    height: 1px;
    background: linear-gradient(90deg, #6c614f 0%, rgba(56, 55, 50, 0) 104.38%);
    ${reverse &&
    css`
      transform: rotateY(180deg);
    `}
  `}
`;
